module.exports = __webpack_public_path__ + "static/media/member_dani.a2d7db5d.jpg";